import { h, Component } from 'preact';
import { accessNested, joinClasses } from 'utils/utils';
import { getValueForClientSize } from 'utils/bolt';
import Buttons from 'components/bolt/hub/components/buttons/buttons';
import Video from 'components/bolt/hub/components/video/video';
import { scale } from 'utils/math';
import { getCopy } from 'utils/copy';
import * as webp from 'utils/bolt/webp';
import s from 'components/bolt/hub/components/hero/hero.sss';
import HTML from 'components/core/html/html';

export default class Hero extends Component {
	constructor(props) {
		super(props);
		this.switchToFallbackImg = this.switchToFallbackImg.bind(this);
		this.state = {
			shouldUseFallbackImg: false
		};
	}

	switchToFallbackImg() {
		this.setState({
			shouldUseFallbackImg: true
		});
	}

	getBgValue(field) {
		const backgroundData = this.props.data.bg;

		if (!backgroundData || !backgroundData.desktop && !backgroundData.tablet && !backgroundData.mobile) {
			return undefined;
		}

		let bgValue = backgroundData.desktop[field];

		if (backgroundData.tablet[field] || backgroundData.mobile[field]) {
			bgValue = {
				desktop: backgroundData.desktop[field],
				tablet: backgroundData.tablet[field],
				mobile: backgroundData.mobile[field]
			};
		}

		return getValueForClientSize(bgValue);
	}


	render({ data, clientDimensions, fallbackFormat }) {
		if (!data) return;

		const asset = this.getBgValue('asset');

		if (!asset) {
			return '';
		}

		const { smallImage, teaser, buttons } = data;
		const { shouldUseFallbackImg } = this.state;
		const fallbackImg = this.getBgValue('fallbackImg');
		const bgPosition = this.getBgValue('bgPosition') || 'center';
		const preLoadImg = this.getBgValue('preLoadImg');
		const isVideoAsset = /\.(mp4|webm)$/.test(asset);
		const hubActivePercentage = accessNested(this.props.store, 'hubActivePercentage', '');
		const scrollFadeOpacity = scale(hubActivePercentage, .8, .6, 0, .6, true);
		const { visible, hide } = this.props;

		const heroId = data.anchor || 'top';

		const imageBgStyle = {
			backgroundImage: webp.css(asset, fallbackFormat),
			backgroundSize: 'cover',
			backgroundPosition: bgPosition
		};

		if (shouldUseFallbackImg) {
			imageBgStyle.backgroundPosition = bgPosition;
			imageBgStyle.backgroundImage = webp.css(fallbackImg, fallbackFormat);
		}

		let title; let filmTitleForTracking;
		const rawTitle = getCopy(data.title) || data.title;


		if (rawTitle) {
			title = encodeURIComponent(rawTitle).split('%0A').map(line => decodeURIComponent(line));
			filmTitleForTracking = title.join('');
		}

		return (
			<div class={joinClasses(s.container, visible && s.visible, hide && s.hide)} data-attribute="boltHubPageHero" data-hash-wrapper={data.anchor || 'top'} id={heroId}>
				<div class={s.scrollFade} style={{ opacity: scrollFadeOpacity }} />
				{isVideoAsset && (
					<Video
						autoplay={false}
						opacity={scrollFadeOpacity}
						src={asset}
						onError={this.switchToFallbackImg}
						preloadImg={preLoadImg}
						fallbackFormat={fallbackFormat}
						hubActivePercentage={hubActivePercentage}
					/>
				)}
				{(!isVideoAsset || shouldUseFallbackImg) && <div class={s.background} style={(!isVideoAsset || shouldUseFallbackImg) && imageBgStyle} />}
				<div class={s.details} style={{ opacity: hubActivePercentage <= 0.5 ? 0 : 1, transform: hubActivePercentage >= 0.5 ? 'translateX(-50%)' : 'translateX(100%)' }}>
					{smallImage && (
						<webp.Picture
							class={s.smallImage}
							src={smallImage}
							alt=""
							fallbackFormat={fallbackFormat}
						/>
					)}
					{title && <h4 class={joinClasses(s.title, 'h4')}>{title.map(line => (line + '\n'))}</h4>}
					<span class={joinClasses(s.teaser, 'xlarge')}><HTML markdown>{getCopy(teaser) || teaser}</HTML></span>
					<Buttons
						heroButtons
						isHero
						data={buttons}
						clientDimensions={clientDimensions}
						filmTitle={filmTitleForTracking}
					/>
				</div>
			</div>
		);
	}
}
